import React, { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { ACCEPTED_TERMS_KEY, CONTACT_OPT_IN_KEY } from '../../DynamicForm.constants';
import { getOptInConfiguration } from '../../DynamicForm.utils';
import { DynamicFormContext } from '../../context/DynamicFormContext';
import CheckboxField from '../fields/CheckboxField';
import DynamicFormFields from '../fields/DynamicFormFields';
function DynamicFormBody() {
  var _useContext = useContext(DynamicFormContext),
    formData = _useContext.formData,
    fields = _useContext.fields,
    consentSettings = _useContext.consentSettings,
    terms = _useContext.terms;
  if (_isEmpty(fields)) {
    return null;
  }
  var contactOptIn = formData.contactOptIn,
    acceptedTerms = formData.acceptedTerms;
  var showOptIn = consentSettings.show;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DynamicFormFields, null), showOptIn && /*#__PURE__*/React.createElement(CheckboxField, {
    field: getOptInConfiguration(consentSettings),
    value: contactOptIn,
    key: CONTACT_OPT_IN_KEY
  }), terms && /*#__PURE__*/React.createElement(CheckboxField, {
    field: {
      label: terms,
      name: ACCEPTED_TERMS_KEY
    },
    value: acceptedTerms,
    key: ACCEPTED_TERMS_KEY
  }));
}
export default DynamicFormBody;